import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { BaseDateValidationMessage, SelectBoxLabel, DateDay, DateMonth, DateYear } from "../date";
import { DateInputWrapper } from "../date/dateInputWrapper";
import Wrapper from "../date/date.styles";
import { useSetDefaultValue } from "@hooks";
import { useDispatch, useSelector } from "react-redux";
import { isUndefined } from "lodash";
import actions from "@redux/loanForm/actions";
import { dateQueryStringParser } from "../../../../services/dateQueryStringParser";
import { MarginLeftRow } from "@components/leftGrid";

const pendingFieldsSelector = state => state.loanForm.pendingFields;

const ariaLabel = "date of birth";

// todo: potentially we could integrate this into usePendingPrefill via making usePendingPrefill a factory which 
//  accepts a parser, the default parser being a one for one map, and dob would use dateQueryStringParser
//  otherwise potentially we could update the sanitizer to convert querystring dates to the date object
//  this feels more correct, but I feel as if I should have come to this solution initially, so why didnt I?
const usePendingPrefillDate = (fieldName) => {
  const dispatch = useDispatch();
  const pendingFields = useSelector(pendingFieldsSelector);
  const pendingField = pendingFields[fieldName];
  const shouldDispatchPendingField = !isUndefined(pendingField);

  useEffect(() => {
    if (shouldDispatchPendingField) {
      const parsedPendingDobField = dateQueryStringParser(pendingField);
      dispatch(actions.setFieldInitialValue({[fieldName]: parsedPendingDobField}));
      dispatch(actions.removePendingField(fieldName));
    }
  }, [dispatch, fieldName, pendingField, shouldDispatchPendingField])
};

export const DobField = () => {
  const name = "dateOfBirth";
  const {
    values: {
      dateOfBirth: { day, month, year } = {}
    },
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
  } = useFormikContext();

  useSetDefaultValue(name, {
    day: "",
    month: "",
    year: "",
  });
  usePendingPrefillDate(name);
  
  return (
    <Wrapper>
      <div className="selectBox">
        <SelectBoxLabel tooltip="You need to be 18 years or older." name={name}>
          Date of Birth
        </SelectBoxLabel>
        <MarginLeftRow className={`selectBox-Input`}>
          <DateInputWrapper xs={12}>
            <DateDay
              ariaLabel={ariaLabel}
              name={name}
              day={day}
              month={month}
              year={year}
              errors={errors}
              touched={touched}
              handleChange={handleChange}
              setFieldValue={setFieldValue}
              handleBlur={handleBlur}
            />
            <DateMonth
              ariaLabel={ariaLabel}
              name={name}
              month={month}
              errors={errors}
              touched={touched}
              handleChange={handleChange}
              handleBlur={handleBlur}
            />
            <DateYear
              ariaLabel={ariaLabel}
              name={name}
              year={year}
              errors={errors}
              touched={touched}
              handleChange={handleChange}
              handleBlur={handleBlur}
              minYear={-18}
              maxYear={-81}
            />
          </DateInputWrapper>
          <BaseDateValidationMessage name={name} errors={errors} touched={touched} />
        </MarginLeftRow>
      </div>
    </Wrapper>
  );
};

export default DobField;
